import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    otpInputField: {
        width: "48px",
        height: "48px",
        border: `2px solid ${theme.palette.emteria.border.primary}`,
        borderRadius: "4px",
        backgroundColor: theme.palette.emteria.background.default,
        outline: "none",
        textAlign: "center",
        fontWeight: "600",
        transition: "border-color 0.3s, color 0.3s",
        color: theme.palette.emteria.text.primary,
        "&:focus": {
            borderWidth: "3px",
            borderColor: theme.palette.emteria.action,
        },
        "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
            appearance: "none",
            margin: 0,
        },
        "&[type=number]": {
            MozAppearance: "textfield",
        },
    },

    otpInputContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(2),
        marginBottom: theme.spacing(6),
    },
    actionButtonContainer: {
        marginTop: theme.spacing(6),
        display: "flex",
        justifyContent: "space-between",
    },
    forumHintText: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(3),
    },
    description: {
        margin: 0,
        marginBottom: theme.spacing(5),
        fontWeight: "normal",
    },
}));
